import { createStore, applyMiddleware, compose } from 'redux';
// import { createLogicMiddleware } from 'redux-logic';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware } from 'connected-react-router';
import { createLogger, LogEntryObject } from 'redux-logger';
import { History } from 'history';
import history from './createHistory';

import rootReducer, { IRootState, IRootAction } from './reducers';
// import arrLogic from './logics';
import rootEpic from './epics';

interface Window {
  [key: string]: any
}

// export const logicMiddleware = createLogicMiddleware<IRootState>(arrLogic);
export const epicMiddleware = createEpicMiddleware<IRootAction, IRootAction, IRootState, void>();

function configureStore(initialState: object, history: History) {
  const middlewares = [
    // logicMiddleware,
    epicMiddleware,
    routerMiddleware(history),
    createLogger({
      collapsed: (getState, action, logEntry) => !logEntry!.error,
    }),
  ];

  const composeEnhancers = (window as Window)['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  return createStore(rootReducer(history), initialState!, enhancer);
}

const store = configureStore({}, history);

epicMiddleware.run(rootEpic);

export default store;
